import React from "react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { 
  Mic, 
  FileText, 
  ListTodo, 
  Bot, 
  LineChart, 
  Tags,
  Database
} from "lucide-react";

const featureSets = [
  {
    icon: Mic,
    title: "Core Features",
    description: "Record, transcribe, and summarize your meetings with advanced AI processing.",
    features: ["Meeting Recording", "Transcription Processing", "Meeting Summaries"],
    cta: "Learn More",
    href: "/how-it-works#core-features"
  },
  {
    icon: ListTodo,
    title: "Action Items Management",
    description: "Turn your meetings into actionable tasks with manual and automated task extraction.",
    features: ["Manual Action Items", "Automated Extraction", "Recurring Tasks"],
    cta: "Explore Tasks",
    href: "/how-it-works#action-items"
  },
  //{
  //  icon: Bot,
  //  title: "AI Assistant & Thoughts",
  //  description: "Get AI-powered support and capture your thoughts seamlessly.",
  //  features: ["AI Chatbot", "Thought Capture", "Intelligent Responses"],
  //  cta: "Meet Your Assistant",
  //  href: "/how-it-works#ai-assistant"
  // },
  {
    icon: LineChart,
    title: "Insights & Analysis",
    description: "Understand meeting dynamics and track decisions with AI analysis.",
    features: ["Sentiment Analysis", "Engagement Tracking", "Decision Analysis"],
    cta: "View Insights",
    href: "/how-it-works#insights"
  },
  //{
  //  icon: Tags,
  //  title: "Organization",
  //  description: "Keep your content organized with smart tagging and categorization.",
  //  features: ["Smart Tagging", "Categorization", "Advanced Search"],
   // cta: "See Organization",
   // href: "/how-it-works#organization"
 // },
  {
    icon: Database,
    title: "Data Management",
    description: "Secure storage and flexible retention for all your meeting data.",
    features: ["Secure Storage", "Flexible Retention", "Easy Retrieval"],
    cta: "Learn About Storage",
    href: "/how-it-works#storage"
  }
];

export default function Solutions() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Transform Your Meetings into Action
          </h1>
          <p className="text-xl text-muted-foreground mb-8">
            Powerful AI-driven tools to capture, analyze, and act on your meetings
          </p>
          <Button asChild size="lg">
            <Link to="/how-it-works">See How It Works</Link>
          </Button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {featureSets.map((set) => (
            <div key={set.title} className="border rounded-lg p-6 bg-card">
              <div className="flex items-center gap-3 mb-4">
                <set.icon className="h-6 w-6 text-primary" />
                <h3 className="text-xl font-semibold">{set.title}</h3>
              </div>
              <p className="text-muted-foreground mb-4">{set.description}</p>
              <ul className="space-y-2 mb-6">
                {set.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-2">
                    <div className="h-1.5 w-1.5 rounded-full bg-primary" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
             {/*} <Button asChild variant="outline" className="w-full">
                <Link to={set.href}>{set.cta}</Link>
              </Button>*/}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}